import type { PropsWithChildren } from 'react'
import { createContext, useContext, useMemo } from 'react'
import type { FileRepository } from './FileRepository'

interface FileContextValue {
  repository: FileRepository
}

export const FileContext = createContext<FileContextValue | null>(null)

export interface FileProviderProps {
  repository: FileRepository
}

export function FileProvider(
  props: PropsWithChildren<FileProviderProps>
): JSX.Element {
  const value = useMemo<FileContextValue>(
    () => ({ repository: props.repository }),
    [props.repository]
  )

  return (
    <FileContext.Provider value={value}>{props.children}</FileContext.Provider>
  )
}

export function useFileContext() {
  const value = useContext(FileContext)
  if (!value) {
    throw new Error('Missing FileProvider context')
  }
  return value
}
